1; /* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    title: "Chi phí phân công",
    value: "",
  },
  {
    id: uuidV4(),
    title: "Chi phí điện",
    value: "",
  },
  {
    id: uuidV4(),
    title: "Chi phí nước",
    value: "",
  },
  {
    id: uuidV4(),
    title: "Chi phí viễn thông",
    value: "",
  },
  {
    id: uuidV4(),
    title: "Chi phí thuê kho bãi, mặt bằng kinh doanh",
    value: "",
  },
  {
    id: uuidV4(),
    title: "Chi phí quản lý (Chi phí văn phòng phẩm, công cụ, dụng cụ,...)",
    value: "",
  },
  {
    id: uuidV4(),
    title:
      "Chi phí khác (hội nghị, công tác phí, thanh lý, nhượng bán tài sản cố định, thuê ngoài khác,...",
    value: "",
  },
];

export default function TaxPersonalTable06({ formData, setFieldValue, count }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, value };
        } else {
          return item;
        }
      })
    );
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Typography variant="h5">I. VẬT LIỆU, DỤNG CỤ, SẢN PHẨM, HÀNG HÓA</Typography>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td className="toggle-button" rowSpan={1} style={{ textAlign: "center" }}>
                Chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Mã chi tiêu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center" }}>
                Số tiền
              </Td>
            </tr>
            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  className="toggle-button"
                  rowSpan={1}
                  style={{ textAlign: "left", fontWeight: 900 }}
                >
                  {item.title}
                </Td>
                <Td
                  className="toggle-button"
                  rowSpan={1}
                  style={{ textAlign: "center", fontWeight: 900 }}
                >
                  [{index + 24}]
                </Td>
                <Td
                  className="toggle-button"
                  rowSpan={1}
                  style={{ textAlign: "right", fontWeight: 900 }}
                >
                  <InputTable
                    id={item.id}
                    name="value"
                    value={item.value}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
            <tr>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "left", background: "#ddeff3", fontWeight: 900 }}
              >
                Tổng cộng
              </Td>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "center", background: "#ddeff3", fontWeight: 900 }}
              >
                [31]
              </Td>
              <Td
                className="toggle-button"
                rowSpan={1}
                style={{ textAlign: "right", background: "#ddeff3", fontWeight: 900 }}
              >
                0
              </Td>
            </tr>
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
